import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface GeoFencesProps {
  color?: string;
  height?: string;
  width?: string;
  style?: React.CSSProperties;
}

export default function GeoFences({
  color = RoutalPalette.primary40,
  height = `19px`,
  width = `18px`,
  style = {},
}: GeoFencesProps) {
  return (
    <SvgIcon viewBox="0 0 18 19" style={{ width, height, fill: `none`, ...style }}>
      <path
        d="M1.79876 7.38136L8.97402 1.89995L15.7273 7.05898L11.2738 10.0046C10.7724 10.3362 10.5781 10.9779 10.8113 11.5321L12.8175 16.2987H4.55437L1.79876 7.38136ZM16.0065 7.2723C16.0064 7.27221 16.0063 7.27212 16.0062 7.27203L16.0065 7.2723ZM1.66018 7.48722L1.66049 7.48698C1.66039 7.48706 1.66029 7.48714 1.66018 7.48722L1.50842 7.28856L1.66018 7.48722Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <circle cx="1.76152" cy="7.2429" r="1.00957" fill={color} stroke={color} strokeWidth="1.5" />
      <circle cx="4.33965" cy="16.2863" r="1.00957" fill={color} stroke={color} strokeWidth="1.5" />
      <circle cx="12.9734" cy="16.2863" r="1.00957" fill={color} stroke={color} strokeWidth="1.5" />
      <circle cx="11.0096" cy="10.762" r="1.00957" fill={color} stroke={color} strokeWidth="1.5" />
      <circle cx="15.7566" cy="7.2429" r="1.00957" fill={color} stroke={color} strokeWidth="1.5" />
      <circle cx="8.97441" cy="1.75957" r="1.00957" fill={color} stroke={color} strokeWidth="1.5" />
    </SvgIcon>
  );
}
